(function($){
  "use strict";

  const behaviorOptions = {
    name: 'IzzyLangSelector',
    selector: '.navmain__langs',
  };

  function behavior(context, settings) {
    setTimeout(() => {
      $(once(behaviorOptions.name, behaviorOptions.selector, context)).each(function (index, element) {
        $(function() {
          window.izzyLangSelector = new IzzyLangSelector(element);
        });
      });
    }, 1000);
  }

  Drupal.behaviors[behaviorOptions.name] = {
    attach: function(context, settings){
      behavior(context, settings);
    },
  }

  // Init self in case we are loaded async.
  if (jQuery.isReady) {
    // It is up to script to define scope and settings it should be applied to
    // in case of jquery mobile integration used you can use site_common.jquery_mobile.getPageContext()
    // to get only current page's context.
    // In this example we use global scope.
    const context = document;
    const settings = Drupal.settings;
    Drupal.behaviors[behaviorOptions.name].attach(context, settings);
  }

  class IzzyLangSelector {
    constructor(element) {
      this.element = element;
      this.$element = $(element);
      this.$items = this.$element.find('a');
      this.isOpened = false;
      this.init();
    }

    init() {
      cutLabels.call(this);
      this.$items.on(`click.${behaviorOptions.name}`, onItemClick.bind(this));
      this.$element.on(`click.${behaviorOptions.name}`, onElementClick.bind(this));
      $(document).on(`click.${behaviorOptions.name}`, onOutClick.bind(this));

      function onItemClick(e) {
        if (e.target.classList.contains('is-active')) {
          e.preventDefault();
        }
      }

      function onElementClick(e) {
        e.stopPropagation();
        this[this.isOpened ? 'close' : 'open']();
      }

      function onOutClick() {
        this.close();
      }

      function cutLabels($items) {
        this.$items.each((i, item) => {
          item.innerText = item.innerText.slice(0, 2);
        });

        this.$element.find('.is-active').parent().addClass('is-first');
        this.$element.addClass('navmain__langs--ready');
      }
    }

    open() {
      this.isOpened = true;
      this.element.classList.add('navmain__langs-main--opened');
    }

    close() {
      this.isOpened = false;
      this.element.classList.remove('navmain__langs-main--opened');
    }
  }
})(jQuery);
